import React, { useEffect, useState} from 'react'
import {Row, Col, Form, Card, Button, Divider, Checkbox, Spin, Modal, Select, Input} from 'antd'
import { connect } from 'react-redux'

import InputField from 'components/InputField'
import TextAreaField from 'components/TextArea'
import SelectField from 'components/SelectField'
import FileUpload from 'components/fileUpload'

import {
    SaveIco,
    SaveBlueIco,
    RefreshIco, SearchIco, MinusSmallIco, PlusSmallIco, ModalCloseIco, InputSearchIco,
    EroorIco,
} from "../../../../../modules/CustomIcons"

import './index.scss'
import '../../transfer.scss'
import {OWNACCOUNT} from "constants/constants";
import {Account, getAccounts, getSavedDocuments} from "../../../../services/account";
import {SelectOptions} from "../../../../services/form";
import {getCurrentCompany, getUserData} from "../../../../services/user";
import {
    checkAmountForRequest,
    fillCurrentForm,
    fillCurrentFormTemplate,
    financial,
    resetForm
} from "../../../../services/helper";
import AmountField from "components/AmountField";
import NextModal from "components/NextModal";
import {BankCodes, getBankCodes} from "../../../../services/moneytransfer";
import {
    getAzipsDocumentNumber,
    getEdvDocumentNumber,
    getHoksDocumentNumber
} from "../../../../services/Accounts/DocumentNumber";
import {newMoneyTransferHoks} from "../../../../services/Transfers/Xohks";
import TemplatePopup from "components/TemplatePopup";
import {getCustomerCommission} from "../../../../services/Customers/Commission";
import SaveAsTemplate from "components/SaveAsTemplate";
import {useLocation} from "react-router-dom";
import {
    GetCustomerBenefAccountData,
    GetCustomerByIban,
    GetCustomerDataByIban
} from "../../../../services/Transfers/GetCustomerByIban";
import {newMoneyTransferAzips} from "../../../../services/Transfers/Azips";
import FullScreenLoading from "components/FullScreenLoading";
import {setIbanNumber } from "../../../../store/actions/accountStatement";
import { useActions } from 'hooks/useActions'
import { useTranslation } from 'react-i18next'
import {getMessageList} from "../../../../services/info";
import {deleteFileById} from "../../../../services/Transfers/Files";


const modalDataInitial={
    modalTitle : 'XÖHKS',
    groups : [

    ],
    edvInfoData : {},
    pdfFiles : [],
    buttons : [
        {save : true},
        {sign : true},
        {approve : true},
        {send : true}
    ]
};

const ibanDataReset = {
    iban: '',
    customerNo: '',
    customerName: '',
    customerStatus: '',
    customerTax: '',
    customerAddress: '',
    ccy: '',
    ccyType: '',
    brAccountType: '',
    showError : false
}

const Hoks: React.FC<any> = ({ ownProps, ibanNumber }) => {
    const {t} = useTranslation()
    const [optionsDet, setOptionsDet] = useState<any[]>([])

    const [visible, setVisible] = useState(false);
    const [showHideEdvBox, setShowHideEdvBox] = useState(false);
    const [allAccounts, setAllAccounts]=useState<Account[]>();
    const [fromSelectOptions, setFromSelectOptions]=useState<SelectOptions[]>();
    const [toSelectOptions, setToSelectOptions]=useState<SelectOptions[]>();
    const [fromBranch, setFromBranch]=useState<Account>();
    const [fromBranch2, setFromBranch2]=useState<Account>();
    const [toBranch, setToBranch]=useState<BankCodes>();
    const [nextModalVisible, setNextModalVisible] = useState(false);
    const [templatePopupVisible, setTemplatePopupVisible] = useState(false);
    const [saveAsTemplatePopupVisible, setSaveAsTemplatePopupVisible] = useState<boolean>(false);
    const [codeModalVisible, setCodeModalVisible] = useState(false);
    const [allBankCodes, setAllBankCodes]=useState<BankCodes>();
    const [modalData, setModalData] = useState(modalDataInitial);
    const [documentNumber, setDocumentNumber] = useState<string>('');
    const [documentNumber2, setDocumentNumber2] = useState<string>('');
    const [bankCodes, setBankCodes]=useState<BankCodes>();
    const [formFields, setFormFields]=useState({});
    const [commissionLoading, setCommissionLoading]=useState(false);
    const [commissionAmount, setCommissionAmount]=useState('');
    const [calcEdv, setCalcEdv]=useState('');
    const [commissionLoading2, setCommissionLoading2]=useState(false);
    const [commissionAmount2, setCommissionAmount2]=useState('');
    const [amountError, setAmountError]=useState(false);
    const [voenError, setVoenError]=useState(false);
    const [benefacceError, setBenefacceError]=useState(false);
    const [tax_required, setTax_required]=useState(false);
    const [userByIbanData, setUserByIbanData]=useState<GetCustomerByIban>(ibanDataReset);
    const [retryRequest, setRetryRequest]=useState(null);
    const [ibanMessage, setIbanMessage] = useState<string>('');
    const [loadingAccount, setLoadingAccount] = useState(false);
    const [loadingData, setLoadingData] = useState(false);
    const [ibankRef, setIbankRef] = useState<string>('');
    const [pdfCount, setPdfCount] = useState(0);
    const [fileList, setFileList] = useState<any[]>([])
    const [tableData, setTableData] = useState<any[]>([])
    const [editOrRepeat,setEdit] = useState(false)
    const [maindetail,setMainDet] = useState<any>('')
    const [isTouched, setIsTouched] = useState(false);
    const [hasError, setHasError] = useState(false);
    const [dropListLoading, setDropListLoading]= useState(false);
    const [form] = Form.useForm();
    const location=useLocation();
    const { setIbanNumber } = useActions();
    const [amountt,setAmountt] = useState<any>();
    const addOrEditPage = ownProps?.addOrEditPage || false;
    const language = localStorage.getItem("i18nextLng")

    const updateParentComponentFormData = async () => {
        if (ownProps?.getFormElements){
            ownProps?.getFormElements({form});
        }
    }

    const getBankcodesMethod = async () => {
        const data = await getBankCodes();

        setAllBankCodes(old_data => data);
    }

    const updateBankCodes = async (modalVisible : boolean = true) => {
        form.setFieldsValue({
            'BENEFBANKNAME' : ''
        });
        const typed_code= !modalVisible && form.getFieldValue('BENEFBANKCODE') || form.getFieldValue('BENEFBANKCODE_FILTER') || '';
        const typed_name=form.getFieldValue('BENEFBANKNAME_FILTER')?.toString()?.toLowerCase() || '';

        if (typed_code.length >= 2 || typed_name.length >= 3){
            const data = !allBankCodes ? await getBankCodes() : allBankCodes;

            setAllBankCodes(old_data => data);

            const filter_codes=data?.filter(row =>
                typed_code && typed_name ? row.CODE.includes(typed_code) && row.NAME.toString().toLowerCase().includes(typed_name) :

                    typed_code ? row.CODE.includes(typed_code) : typed_name ? row.NAME.toString().toLowerCase().includes(typed_name) : row
            );

            setFormFields(old_data => ({
                ...old_data,
                BENEFBANKCODE : typed_code,
            }))

            setBankCodes(old_data => filter_codes);
            setToBranch(old_data => filter_codes[0])
        }else{
            setBankCodes(old_data => bankCodes);
            setToBranch(old_data => toBranch);
        }

        setCodeModalVisible(modalVisible);
    }

    const resetFilterCode = (e) => {
        let val_length=parseInt(e.target?.value?.trim()?.length);

        if (isNaN(val_length) || val_length ==0){

            form.resetFields(['BENEFBANKNAME']);

            setFormFields(old_data => {})

            setBankCodes(old_data => bankCodes);
            setToBranch(old_data => toBranch);
        }
    }

    const resetFormFields = () => {
        setFormFields(old_data => {});
        setCalcEdv(old_value => '');
        setCommissionAmount2(old_value => '');
        setShowHideEdvBox(false);
    }

    const updateToBankCodeAndName = (row) => {

        setFormFields(old_data => ({
            ...old_data,
            BENEFBANKCODE : row.CODE,
            BENEFBANKNAME : row.NAME,
        }))

        setCodeModalVisible(false);
        setTimeout(() => { calculateCommission({target: {value :form.getFieldValue('AMOUNT') }}) }, 100)
    }

    const fetchData = async () => {
        setLoadingAccount(true)
        const data = await getAccounts(getCurrentCompany());

        let temp_data=[];

        for (let row of data ){
            if(row.STATUS !== "0") {
                if (row.CCY_NAME.toString().toLowerCase() !== 'azn') {
                    continue;
                }

                // @ts-ignore
                temp_data.push({
                    label: row.NICKNAME ? row.NICKNAME : row.IBAN,
                    value: row.IBAN,
                    extra: `${financial(row.BALANCE_LC)} ${row.CCY_NAME}`
                });
            }
        }


        setAllAccounts(data.filter(row => row.STATUS !== "0"));
        setFromSelectOptions(old_data => temp_data);
        setToSelectOptions(old_data => temp_data);

        /**/
        if (location?.state?.trnData){
            fillCurrentForm(form, location.state.trnData)
        }
        setLoadingAccount(false)
    };

    useEffect(() => {
        updateParentComponentFormData()
    }, [showHideEdvBox]);

    const fetchDataDropList = async () => {
        setDropListLoading(true)
        const data = await getMessageList();
        let temp_data=[];
        if(data.messageList !== undefined && data.messageList !== null && data.messageList.length > 0) {
            for (let row of data.messageList) {
                if (row.messageKey.toString().includes("DROP.ALL")) {
                    // @ts-ignore
                    let labelText;
                    switch(language) {
                        case 'az':
                            labelText = row.textAZE;
                            break;
                        case 'ru':
                            labelText = row.textRU;
                            break;
                        case 'en':
                            labelText = row.textENG;
                            break;
                        default:
                            labelText = row.textAZE;
                    }

                    temp_data.push({
                        label: labelText,
                        value:  labelText,
                    });
                }
            }
        }
        setDropListLoading(false)
        console.log(temp_data)
        setOptionsDet(old_data => temp_data);

    };

    useEffect(() => {
        fetchDataDropList();
        if(location.state?.data) {
            loadData()
        } else if(location.state?.trnData)
            loadDataTemplate2(location.state)
        else {
            fetchData();
            getBankcodesMethod();
        }

    }, [location.state]);

    const loadData = async () => {
        setLoadingData(true)
        setLoadingAccount(true)
        setAmountError(false)
        const data = await getAccounts(getCurrentCompany());

        let temp_data: SelectOptions[] | undefined=[];

        for (let row of data ){
            if(row.STATUS !== "0") {
                if (row.CCY_NAME.toString().toLowerCase() !== 'azn') {
                    continue;
                }

                temp_data.push({
                    label: row.NICKNAME ? row.NICKNAME : row.IBAN,
                    value: row.IBAN,
                    extra: `${financial(row.BALANCE_LC)} ${row.CCY_NAME}`
                });
            }
        }

        setAllAccounts(data.filter(row => row.STATUS !== "0"));
        setFromSelectOptions(old_data => temp_data);
        setToSelectOptions(old_data => temp_data);
        setLoadingAccount(false)
        const pdf = await getSavedDocuments(location.state?.data['ibankRef'])
        setFileList(pdf.data?.fileDetailsList)
        if (location.state?.edit){
            setEdit(true)
        }else{
            setEdit(false)
        }

        setTableData(location.state?.data)
        const dataBankCode = await getBankCodes();
        setAllBankCodes(old_data => dataBankCode);
        if(location.state?.edit)
            setIbankRef(location.state?.data['ibankRef'])
        setPdfCount(location.state?.data['attachedPDF'])
        // CUSTACC
        const findAccount = data?.find(row => row.IBAN == location.state?.data['CUSTACC'] && row.STATUS !== "0");
        if(findAccount !== undefined) {
            setFromBranch(findAccount);
            if ((form.getFieldValue('PMTCUSTID') === "" || form.getFieldValue('PMTCUSTID') === undefined) && location.state?.edit === undefined){
                updateDocumentNumber();
            } else if(location.state?.edit) {
                form.setFieldsValue({
                    'PMTCUSTID' : location.state?.data['PMTCUSTID']
                });
            }
            if (!form.getFieldValue('PMTCUSTID2') && location.state?.data['CUSTACC']) {
                setFromBranch2(findAccount);
            }
            form.setFieldsValue({
                'CUSTACC': location.state?.data['CUSTACC']
            });
        }

        // BENEFNAME
        form.setFieldsValue({
            'BENEFNAME': location.state?.data['COUNTERNAME']
        });

        form.setFieldsValue({
            'NOTE': location.state?.data['NOTE']
        });
        // BENEFACC
        if(location.state?.data['BENEFACC'] !== undefined && location.state?.data['BENEFACC'].length === 28 && !location.state?.data['BENEFACC'].toString().includes("BRES")) {
            form.setFieldsValue({
                'BENEFACC': location.state?.data['BENEFACC']
            });
            setBenefacceError(false)
        }

        // BENEFTAXID
        if(location.state?.data['BENEFTAXID'] !== undefined) {
            form.setFieldsValue({
                'BENEFTAXID': location.state?.data['BENEFTAXID']
            });
            setVoenError(false)
        }

        // BENEFBANKCODE   BENEFBANKNAME
        const filter_codes = dataBankCode?.filter(row =>
            row.CODE.includes(location.state?.data['BENEFBANKCODE'])
        );

        if(filter_codes !== undefined && filter_codes.length > 0) {
            setToBranch(old_data => filter_codes[0]);
            setFormFields(old_data => ({
                ...old_data,
                BENEFBANKCODE: filter_codes[0].CODE,
                BENEFBANKNAME: filter_codes[0].NAME,
            }))
        }

        // AMOUNT
        form.setFieldsValue({
            'AMOUNT': checkAmountForRequest(location.state?.data['AMOUNT'])
        });
        setAmountt(checkAmountForRequest(location.state?.data['AMOUNT']));
            if(checkAmountForRequest(location.state?.data['AMOUNT'])>40000){
                setAmountError(true)
            }
        // PMTDET
        // const firstFindedMain=location.state?.data['PMTDET'].substring(0, location.state?.data['PMTDET'].indexOf(' '))
        // console.log(optionsDet.filter(row=>row.label.startsWith(firstFindedMain)))
        // const filteredOptions= optionsDet.filter(row=>row.label.startsWith(firstFindedMain))
        // if(filteredOptions.length===0 || firstFindedMain.length===0) {
        //     form.setFieldsValue({
        //         'PMTDET': location.state?.data['PMTDET']
        //     });
        //     setMainDet('')

        //     form.setFieldsValue({
        //         'MAINDET': undefined
        //     });
        // }else{
        //     for(var item in filteredOptions){
        //         console.log(filteredOptions[item])
        //         console.log(location.state?.data['PMTDET'].includes(filteredOptions[item].label))
        //         if(location.state?.data['PMTDET'].includes(filteredOptions[item].label)){
        //             form.setFieldsValue({
        //                 'MAINDET': filteredOptions[item].label
        //             });
        //             setMainDet(filteredOptions[item].label)
        //             const pmtdet= location.state?.data['PMTDET'].replace(filteredOptions[item].label,'')
        //             form.setFieldsValue({
        //                 'PMTDET': pmtdet
        //             });
        //         }


        //     }
        // }
        //MAINDET
        console.log(location.state?.data['mainDetail'])

        if(location.state?.data['mainDetail']!==undefined && location.state?.data['mainDetail']!==null && location.state?.data['mainDetail']!==''){
            form.setFieldsValue({
                'MAINDET': location.state?.data['mainDetail']
            });
            setMainDet(location.state?.data['mainDetail'])
            if(location.state?.data['PMTDET']?.includes(location.state?.data['mainDetail'])) {
                const PMTDETAILWithoutMainDet = location.state?.data['PMTDET'].replace(location.state?.data['mainDetail'], '').trim();
                console.log(
                    'isledi 441'
                )
                form.setFieldsValue({
                    'PMTDET':  PMTDETAILWithoutMainDet.length > 105 ? PMTDETAILWithoutMainDet.substring(0,105):PMTDETAILWithoutMainDet
                });
            }else{
                console.log(
                    'isledi 566'
                )
                form.setFieldsValue({
                    'PMTDET':location.state?.data['PMTDET']
                });
            }
        }else{
            if(location.state?.data['BENEFTAXID'] !== undefined && location.state?.data['BENEFTAXID'] !== null) {
                form.setFieldsValue({
                    'PMTDET': location.state?.data['PMTDET']
                });
                }else{
                form.setFieldsValue({
                    'PMTDET': location.state?.data['PMTDET'].length > 105 ?  location.state?.data['PMTDET'].substring(0,105): location.state?.data['PMTDET']
                });
                }
                form.setFieldsValue({
                    'MAINDET': undefined
                });
                setMainDet('')
        }
        // INFOTOBENEF2
        form.setFieldsValue({
            'INFOTOBENEF': location.state?.data['INFOTOBENEF']?.length >195 ? location.state?.data['INFOTOBENEF'].substring(0,195) : location.state?.data['INFOTOBENEF']
        });

        // CALC COMISSION
        // @ts-ignore
        let value = checkAmountForRequest(location.state?.data['AMOUNT']);
        setCalcEdv(old_value => '');
        let parsedValue = parseFloat(value).toFixed(2);
        // @ts-ignore
        if (!isNaN(value)) {
            if (parsedValue <= 40000 ){
                setAmountError(false);
                setCommissionLoading(true);
                let calc_percent=(value * 18 ) / 100;
                setCalcEdv(old_value => calc_percent);
                getCustomerCommission({
                    PAYMENT_TYPE : "XOHKS",
                    CIF : getCurrentCompany().customerNo,
                    CUSTACC : findAccount?.IBAN,
                    AMOUNT : value,
                    CUR : findAccount?.CCY_NAME,
                    BENEFBANKCODE : location.state?.data['BENEFBANKCODE'],
                    BENEFACC : location.state?.data['BENEFACC'],
                    BENEFTAXID : location.state?.data['BENEFTAXID'],
                    PMTDET : location.state?.data['PMTDET'],
                }).then(res => {
                    setCommissionLoading(false);
                    setCommissionAmount( res.COM_AMOUNT ?? '')
                    form.setFieldsValue({
                        'CUSTACCFORCOM' : res.COM_AMOUNT ?? ''
                    });
                })
            } else {
                setAmountError(true);
            }
        }
        else {
            setCommissionLoading(false);
            form.setFieldsValue({
                'CUSTACCFORCOM' : ''
            });
            setCommissionAmount(old_value => '');
        }
        if(location.state?.data['PMTAMOUNT2'] !== undefined && location.state?.data['PMTAMOUNT2'] !== "" && location.state?.data['PMTAMOUNT2'] !== null) {
            updateDocumentNumber2(false)
            let getValue = location.state?.data['PMTAMOUNT2'];
            let parsed_value = parseFloat(getValue?.toString().replace(/\s/g, ''));
            let value1 = parsed_value.toFixed(2);
            setShowHideEdvBox(old_value => true);
            form.setFieldsValue({
                'PMTDET2': location.state?.data['PMTDET2']
            });
            const findAccount1 = data?.find(row => row.IBAN == location.state?.data['CUSTACC2'] && row.STATUS !== "0");
            if(findAccount1 !== undefined) {
                setFromBranch2(findAccount1);
            }
            // form.setFieldsValue({
            //     'PMTCUSTID2': tempData?.trnData.PMTCUSTID2
            // });

            form.setFieldsValue({
                'PMTAMOUNT2': location.state?.data['PMTAMOUNT2']
            });
            form.setFieldsValue({
                'INFOTOBENEF2': location.state?.data['INFOTOBENEF2']?.length >195 ? location.state?.data['INFOTOBENEF2'].substring(0,195) : location.state?.data['INFOTOBENEF2']
            });

            if (!isNaN(value1)) {
                setCommissionLoading2(true);
                setCalcEdv(old_value => value1);
                getCustomerCommission({
                    PAYMENT_TYPE: "EDV",
                    CIF: getCurrentCompany().customerNo,
                    CUSTACC: findAccount?.IBAN,
                    AMOUNT: value1,
                    CUR: findAccount?.CCY_NAME,
                    BENEFBANKCODE: location.state?.data['BENEFBANKCODE'],
                    BENEFACC: location.state?.data['BENEFACC'],
                    BENEFTAXID: location.state?.data['BENEFTAXID'],
                    PMTDET: location.state?.data['PMTDET'],
                }).then(res => {
                    setCommissionLoading2(false);
                    form.setFieldsValue({
                        'COMMAMOUNT2': res.COM_AMOUNT ?? ''
                    });
                    setCommissionAmount2(old_value => res.COM_AMOUNT ?? '')
                })
            } else {
                setCommissionLoading2(false);
                form.setFieldsValue({
                    'COMMAMOUNT2': ''
                });
                setCalcEdv(old_value => '');
                setCommissionAmount2(old_value => '');
            }
        }

        setLoadingData(false)
    }

    const loadDataTemplate = async (tempData) => {
        setLoadingData(true)
        setShowHideEdvBox(false)
        setAmountError(false)
        setAmountt(tempData?.trnData.AMOUNT);
        const docid = documentNumber;
        form.resetFields();
        if (tempData?.trnData) {
            await fillCurrentFormTemplate(form, tempData?.trnData)
            await updateParentComponentFormData();
        }
        if(docid !== "" && docid !== undefined) {
            form.setFieldsValue({
                'PMTCUSTID': docid
            });
            setDocumentNumber(old_value => docid)
        }
        // CUSTACC
        const findAccount = allAccounts?.find(row => row.IBAN == tempData?.trnData.CUSTACC && row.STATUS !== "0");
        if(findAccount !== undefined) {
            setFromBranch(findAccount);
            // if (docid === "" || docid === undefined) {
                await updateDocumentNumber();
            // }
            form.setFieldsValue({
                'CUSTACC': tempData?.trnData.CUSTACC
            });
        }

        // BENEFNAME
        form.setFieldsValue({
            'BENEFNAME': tempData?.trnData.BENEFNAME
        });

        form.setFieldsValue({
            'NOTE': tempData?.trnData.NOTE
        });

        // BENEFACC
        if(tempData?.trnData.BENEFACC !== undefined && tempData?.trnData.BENEFACC.length === 28 && !tempData?.trnData.BENEFACC.toString().includes("BRES")) {
            form.setFieldsValue({
                'BENEFACC': tempData?.trnData.BENEFACC
            });
            setBenefacceError(false)
        }

        // BENEFTAXID
        if(tempData?.trnData.BENEFTAXID !== undefined) {
            form.setFieldsValue({
                'BENEFTAXID': tempData?.trnData.BENEFTAXID
            });
            setVoenError(false)
        }

        // BENEFBANKCODE   BENEFBANKNAME
        const dataBankCode = await getBankCodes();
        const filter_codes = dataBankCode?.filter(row =>
            row.CODE.includes(tempData?.trnData.BENEFBANKCODE)
        );

        if(filter_codes !== undefined && filter_codes.length > 0) {
            setToBranch(old_data => filter_codes[0]);
            setFormFields(old_data => ({
                ...old_data,
                BENEFBANKCODE: filter_codes[0].CODE,
                BENEFBANKNAME: filter_codes[0].NAME,
            }))
        }

        // AMOUNT
        form.setFieldsValue({
            'AMOUNT': checkAmountForRequest(tempData?.trnData.AMOUNT)
        });
            if(checkAmountForRequest(tempData?.trnData.AMOUNT)>40000) {
                setAmountError(true)
            }
        // PMTDET
 
        if((tempData?.trnData.MAINDET !==undefined && tempData?.trnData.MAINDET  !==null)||(tempData?.trnData.mainDetail !==undefined && tempData?.trnData.mainDetail  !==null&& tempData?.trnData.mainDetail  !== "")){
            console.log(tempData?.trnData.MAINDET)
            console.log(tempData?.trnData.PMTDET)
            form.setFieldsValue({
                'MAINDET': tempData?.trnData.MAINDET||tempData?.trnData.mainDetail
            });
            setMainDet(tempData?.trnData.MAINDET||tempData?.trnData.mainDetail)
            if(tempData?.trnData.PMTDET?.includes(tempData?.trnData.MAINDET||tempData?.trnData.mainDetail)) {
                const PMTDETAILWithoutMainDet = tempData?.trnData.PMTDET.replace(tempData?.trnData.MAINDET||tempData?.trnData.mainDetail, '').trim();
                console.log(
                    'isledi 560'
                )
                form.setFieldsValue({
                    'PMTDET':  PMTDETAILWithoutMainDet.length > 105 ? PMTDETAILWithoutMainDet.substring(0,105):PMTDETAILWithoutMainDet
                });
            }else{
                console.log(
                    'isledi 566'
                )
                form.setFieldsValue({
                    'PMTDET':tempData?.trnData?.PMTDET
                });
            }
        }else{
            console.log(
                'isledi 577'
            )
            console.log(tempData?.trnData.BENEFTAXID)
            if(tempData?.trnData.BENEFTAXID !== undefined && tempData?.trnData.BENEFTAXID !== null) {
            form.setFieldsValue({
                'PMTDET': tempData?.trnData.PMTDET
            });
            }else{
            form.setFieldsValue({
                'PMTDET': tempData?.trnData.PMTDET.length > 105 ?  tempData?.trnData.PMTDET.substring(0,105): tempData?.trnData.PMTDET.trim()
            });
            }
            form.setFieldsValue({
                'MAINDET': undefined
            });
            setMainDet('')
        }
        // INFOTOBENEF2
        form.setFieldsValue({
            'INFOTOBENEF': tempData?.trnData?.INFOTOBENEF?.length >195 ? tempData?.trnData?.INFOTOBENEF.substring(0,195) : tempData?.trnData?.INFOTOBENEF
        });

        // CALC COMISSION
        // @ts-ignore
        let value = checkAmountForRequest(tempData?.trnData.AMOUNT);
        setCalcEdv(old_value => '');

        // @ts-ignore
        if (!isNaN(value)) {
            setCommissionLoading(true);
            let calc_percent=(value * 18 ) / 100;
            setCalcEdv(old_value => calc_percent);
            const res = await getCustomerCommission({
                PAYMENT_TYPE : "XOHKS",
                CIF : getCurrentCompany().customerNo,
                CUSTACC : findAccount?.IBAN,
                AMOUNT : value,
                CUR : findAccount?.CCY_NAME,
                BENEFBANKCODE : tempData?.trnData.BENEFBANKCODE,
                BENEFACC : tempData?.trnData.BENEFACC,
                BENEFTAXID : tempData?.trnData.BENEFTAXID,
                PMTDET : tempData?.trnData.PMTDET,
            })

            if(res !== undefined) {
                setCommissionLoading(false);
                setCommissionAmount( res.COM_AMOUNT ?? '')
                form.setFieldsValue({
                    'CUSTACCFORCOM' : res.COM_AMOUNT ?? ''
                });
            }
        }
        else {
            setCommissionLoading(false);
            form.setFieldsValue({
                'CUSTACCFORCOM' : ''
            });
            setCommissionAmount(old_value => '');
        }

        if(tempData?.trnData.PMTAMOUNT2 !== undefined && tempData?.trnData.PMTAMOUNT2 !== "" && tempData?.trnData.PMTAMOUNT2 !== null) {
            await updateDocumentNumber2(false)
            let getValue = tempData?.trnData.PMTAMOUNT2;
            let parsed_value = parseFloat(getValue?.toString().replace(/\s/g, ''));
            let value1 = parsed_value.toFixed(2);
            setShowHideEdvBox(old_value => true);
            form.setFieldsValue({
                'PMTDET2': tempData?.trnData.PMTDET2
            });

            const findAccount1 = allAccounts?.find(row => row.IBAN == tempData?.trnData.CUSTACC2 && row.STATUS !== "0");
            if(findAccount1 !== undefined) {
                setFromBranch2(findAccount1);
            }

            form.setFieldsValue({
                'PMTAMOUNT2': tempData?.trnData.PMTAMOUNT2
            });
            form.setFieldsValue({
                'INFOTOBENEF2': tempData?.trnData?.INFOTOBENEF2?.length >195 ? tempData?.trnData?.INFOTOBENEF2.substring(0,195) : tempData?.trnData?.INFOTOBENEF2
            });

            if (!isNaN(value1)) {
                setCommissionLoading2(true);
                setCalcEdv(old_value => value1);
                const res = await getCustomerCommission({
                    PAYMENT_TYPE: "EDV",
                    CIF: getCurrentCompany().customerNo,
                    CUSTACC: findAccount?.IBAN,
                    AMOUNT: value1,
                    CUR: findAccount?.CCY_NAME,
                    BENEFBANKCODE: tempData?.trnData.BENEFBANKCODE,
                    BENEFACC: tempData?.trnData.BENEFACC,
                    BENEFTAXID: tempData?.trnData.BENEFTAXID,
                    PMTDET: tempData?.trnData.PMTDET,
                })

                if(res !== undefined) {
                    setCommissionLoading2(false);
                    form.setFieldsValue({
                        'COMMAMOUNT2': res.COM_AMOUNT ?? ''
                    });
                    setCommissionAmount2(old_value => res.COM_AMOUNT ?? '')
                }

            } else {
                setCommissionLoading2(false);
                form.setFieldsValue({
                    'COMMAMOUNT2': ''
                });
                setCalcEdv(old_value => '');
                setCommissionAmount2(old_value => '');
            }
        }
        setLoadingData(false)
    }

    const loadDataTemplate2 = async (tempData) => {
        setLoadingData(true)
        setLoadingAccount(true)
        setAmountError(false)
        const data = await getAccounts(getCurrentCompany());

        let temp_data: SelectOptions[] | undefined=[];

        for (let row of data ){
            if(row.STATUS !== "0") {
                if (row.CCY_NAME.toString().toLowerCase() !== 'azn') {
                    continue;
                }

                temp_data.push({
                    label: row.NICKNAME ? row.NICKNAME : row.IBAN,
                    value: row.IBAN,
                    extra: `${financial(row.BALANCE_LC)} ${row.CCY_NAME}`
                });
            }
        }
        setAllAccounts(data.filter(row => row.STATUS !== "0"));
        setFromSelectOptions(old_data => temp_data);
        setToSelectOptions(old_data => temp_data);
        setLoadingAccount(false)
        const dataBankCode = await getBankCodes();
        setAllBankCodes(old_data => dataBankCode);
        // CUSTACC
        const findAccount = data?.find(row => row.IBAN == tempData?.trnData.CUSTACC && row.STATUS !== "0");
        if(findAccount !== undefined) {
            setFromBranch(findAccount);
            // if (form.getFieldValue('PMTCUSTID') === "" || form.getFieldValue('PMTCUSTID') === undefined) {
                updateDocumentNumber();
            // }
            form.setFieldsValue({
                'CUSTACC': tempData?.trnData.CUSTACC
            });
        }

        // BENEFNAME
        form.setFieldsValue({
            'BENEFNAME': tempData?.trnData.BENEFNAME
        });

        form.setFieldsValue({
            'NOTE': tempData?.trnData.NOTE
        });

        // BENEFACC
        if(tempData?.trnData.BENEFACC !== undefined && tempData?.trnData.BENEFACC.length === 28 && !tempData?.trnData.BENEFACC.toString().includes("BRES")) {
            form.setFieldsValue({
                'BENEFACC': tempData?.trnData.BENEFACC
            });
            setBenefacceError(false)
        }

        // BENEFTAXID
        if(tempData?.trnData.BENEFTAXID !== undefined) {
            form.setFieldsValue({
                'BENEFTAXID': tempData?.trnData.BENEFTAXID
            });
            setVoenError(false)
        }

        // BENEFBANKCODE   BENEFBANKNAME
        const filter_codes = dataBankCode?.filter(row =>
            row.CODE.includes(tempData?.trnData.BENEFBANKCODE)
        );

        if(filter_codes !== undefined && filter_codes.length > 0) {
            setToBranch(old_data => filter_codes[0]);
            setFormFields(old_data => ({
                ...old_data,
                BENEFBANKCODE: filter_codes[0].CODE,
                BENEFBANKNAME: filter_codes[0].NAME,
            }))
        }

        // AMOUNT
        form.setFieldsValue({
            'AMOUNT': checkAmountForRequest(tempData?.trnData.AMOUNT)
        });
        if(checkAmountForRequest(tempData?.trnData.AMOUNT)>40000){
            setAmountError(true)
        }
        // PMTDET
        if((tempData?.trnData.MAINDET !==undefined && tempData?.trnData.MAINDET  !==null)||(tempData?.trnData.mainDetail !==undefined && tempData?.trnData.mainDetail  !==null&& tempData?.trnData.mainDetail  !== "")){
            console.log(tempData?.trnData.MAINDET)
            console.log(tempData?.trnData.PMTDET)
            form.setFieldsValue({
                'MAINDET': tempData?.trnData.MAINDET||tempData?.trnData.mainDetail 
            });
            setMainDet(tempData?.trnData.MAINDET||tempData?.trnData.mainDetail )
            if(tempData?.trnData.PMTDET?.includes(tempData?.trnData.MAINDET||tempData?.trnData.mainDetail )) {
                const PMTDETAILWithoutMainDet = tempData?.trnData.PMTDET.replace(tempData?.trnData.MAINDET||tempData?.trnData.mainDetail , '').trim();
                console.log(
                    'isledi 560'
                )
                form.setFieldsValue({
                    'PMTDET':  PMTDETAILWithoutMainDet.length > 105 ? PMTDETAILWithoutMainDet.substring(0,105):PMTDETAILWithoutMainDet
                });
            }else{
                console.log(
                    'isledi 566'
                )
                form.setFieldsValue({
                    'PMTDET':tempData?.trnData?.PMTDET
                });
            }
        }else{
            console.log(
                'isledi 577'
            )
            console.log(tempData?.trnData.BENEFTAXID)
            if(tempData?.trnData.BENEFTAXID !== undefined && tempData?.trnData.BENEFTAXID !== null) {
            form.setFieldsValue({
                'PMTDET': tempData?.trnData.PMTDET
            });
            }else{
            form.setFieldsValue({
                'PMTDET': tempData?.trnData.PMTDET.length > 105 ?  tempData?.trnData.PMTDET.substring(0,105): tempData?.trnData.PMTDET.trim()
            });
            }
            form.setFieldsValue({
                'MAINDET': undefined
            });
            setMainDet('')
        }

        // INFOTOBENEF2
        form.setFieldsValue({
            'INFOTOBENEF': tempData?.trnData?.INFOTOBENEF?.length > 195 ?  tempData?.trnData?.INFOTOBENEF.substring(0,195): tempData?.trnData?.INFOTOBENEF
        });

        // CALC COMISSION
        // @ts-ignore
        let value = checkAmountForRequest(tempData?.trnData.AMOUNT);
        setCalcEdv(old_value => '');

        // @ts-ignore
        if (!isNaN(value)) {
            setCommissionLoading(true);
            let calc_percent=(value * 18 ) / 100;
            setCalcEdv(old_value => calc_percent);
            const res = await getCustomerCommission({
                PAYMENT_TYPE : "XOHKS",
                CIF : getCurrentCompany().customerNo,
                CUSTACC : findAccount?.IBAN,
                AMOUNT : value,
                CUR : findAccount?.CCY_NAME,
                BENEFBANKCODE : tempData?.trnData.BENEFBANKCODE,
                BENEFACC : tempData?.trnData.BENEFACC,
                BENEFTAXID : tempData?.trnData.BENEFTAXID,
                PMTDET : tempData?.trnData.PMTDET,
            })
            if(res !== undefined) {
                setCommissionLoading(false);
                setCommissionAmount( res.COM_AMOUNT ?? '')
                form.setFieldsValue({
                    'CUSTACCFORCOM' : res.COM_AMOUNT ?? ''
                });
            }
        }
        else {
            setCommissionLoading(false);
            form.setFieldsValue({
                'CUSTACCFORCOM' : ''
            });
            setCommissionAmount(old_value => '');
        }

        if(tempData?.trnData.PMTAMOUNT2 !== undefined && tempData?.trnData.PMTAMOUNT2 !== "" && tempData?.trnData.PMTAMOUNT2 !== null) {
            setShowHideEdvBox(old_value => true);
            let getValue = tempData?.trnData.PMTAMOUNT2;
            let parsed_value = parseFloat(getValue?.toString().replace(/\s/g, ''));
            let value1 = parsed_value.toFixed(2);

            form.setFieldsValue({
                'PMTDET2': tempData?.trnData.PMTDET2
            });

            const findAccount1 = data?.find(row => row.IBAN == tempData?.trnData.CUSTACC2 && row.STATUS !== "0");
            if(findAccount1 !== undefined) {
                setFromBranch2(findAccount1);
            }

            form.setFieldsValue({
                'PMTCUSTID2': tempData?.trnData.PMTCUSTID2
            });

            form.setFieldsValue({
                'PMTAMOUNT2': tempData?.trnData.PMTAMOUNT2
            });
            form.setFieldsValue({
                'INFOTOBENEF2': tempData?.trnData?.INFOTOBENEF2?.length >195 ? tempData?.trnData?.INFOTOBENEF2.substring(0,195) : tempData?.trnData?.INFOTOBENEF2
            });

            if (!isNaN(value1)) {
                setCommissionLoading2(true);
                setCalcEdv(old_value => value1);
                const res = await getCustomerCommission({
                    PAYMENT_TYPE: "EDV",
                    CIF: getCurrentCompany().customerNo,
                    CUSTACC: findAccount?.IBAN,
                    AMOUNT: value1,
                    CUR: findAccount?.CCY_NAME,
                    BENEFBANKCODE: tempData?.trnData.BENEFBANKCODE,
                    BENEFACC: tempData?.trnData.BENEFACC,
                    BENEFTAXID: tempData?.trnData.BENEFTAXID,
                    PMTDET: tempData?.trnData.PMTDET2,
                })
                if(res !== undefined) {
                    setCommissionLoading2(false);
                    form.setFieldsValue({
                        'COMMAMOUNT2': res.COM_AMOUNT ?? ''
                    });
                    setCommissionAmount2(old_value => res.COM_AMOUNT ?? '')
                }
            } else {
                setCommissionLoading2(false);
                form.setFieldsValue({
                    'COMMAMOUNT2': ''
                });
                setCalcEdv(old_value => '');
                setCommissionAmount2(old_value => '');
            }
        }
        updateParentComponentFormData()
        setLoadingData(false)
    }

    const updateDocumentNumber = async () => {
        const document_number = await  getHoksDocumentNumber(getCurrentCompany());
        form.setFieldsValue({
            'PMTCUSTID' : document_number
        });

        setDocumentNumber(old_value => document_number)
    }

    const updateDocumentNumber2 = async (setDetail: boolean) => {
        const document_number = await  getEdvDocumentNumber(getCurrentCompany());
        form.setFieldsValue({
            'PMTCUSTID2' : document_number
        });
        if(setDetail) {
            form.setFieldsValue({
                'PMTDET2': form.getFieldValue("PMTDET")
            });
        }
        setDocumentNumber2(old_value => document_number)
    }

    const getSelectedFromBranch = (value:any) => {
        const findAccount=allAccounts?.find(row => row.IBAN==value);
        setFromBranch(findAccount);

        if (!form.getFieldValue('PMTCUSTID') && value){
            updateDocumentNumber();
        }

        if (!form.getFieldValue('PMTCUSTID2') && value){
            getSelectedFromBranch2(value);
        }
    }

    const getSelectedFromBranch2 = (value:any) => {
        const findAccount=allAccounts?.find(row => row.IBAN==value);
        setFromBranch2(findAccount);
    }

    useEffect(() => {
        if(ibanNumber.iban && allAccounts && ibanNumber.ccy_name?.toString()?.toLowerCase() === 'azn'){
        const findAccount=allAccounts?.find(row => row.IBAN==ibanNumber.iban);
        setFromBranch(findAccount);

        if (!form.getFieldValue('PMTCUSTID') && ibanNumber.iban){
            updateDocumentNumber();
        }

        if (!form.getFieldValue('PMTCUSTID2') && ibanNumber.iban){
            getSelectedFromBranch2(ibanNumber.iban);
        }
        setIbanNumber({iban: undefined, ccy_name: undefined})
        }

      }, [ibanNumber, allAccounts])

useEffect(() => {
    setPdfCount(form.getFieldValue('pdf_files')?.length)
},[form.getFieldValue('pdf_files')])

    const newTransferFunc = async(RequestType : string, retry : boolean = false) => {
        let amount=checkAmountForRequest(form.getFieldValue('AMOUNT'));
        let amount2=checkAmountForRequest(form.getFieldValue('PMTAMOUNT2')) ?? null;
        let comission=checkAmountForRequest(form.getFieldValue('CUSTACCFORCOM')) ?? null;
        let detail= form.getFieldValue('PMTDET') !== undefined ? form.getFieldValue('PMTDET'):''
        let pdf_files=form.getFieldValue('pdf_files') ?? [];
       if(ibankRef !== "") {
              await   deleteFileById(ibankRef)
              await new Promise(res => setTimeout(res, 1000)); 
             }
        if(!retry && retryRequest === null) {
            const req = {
                xohks : {
                    trnRequestType : RequestType,
                    ccy : 1,
                    ccyType : fromBranch?.CCY_NAME,
                    CUSTCIF: getCurrentCompany().customerNo,
                    CUSTACC : fromBranch?.IBAN,
                    PMTCUSTID : form.getFieldValue('PMTCUSTID'),
                    BENEFNAME : form.getFieldValue('BENEFNAME'),
                    BENEFACC : form.getFieldValue('BENEFACC')?.toUpperCase(),
                    BENEFTAXID : form.getFieldValue('BENEFTAXID'),
                    BENEFBANKCODE : form.getFieldValue('BENEFBANKCODE'),
                    BENEFBANKNAME : toBranch?.NAME,
                    BENEFBANKTAXID : toBranch?.VOEN,
                    BENEFBANKCORACC : toBranch?.CORR_ACCOUNT,
                    BENEFBANKSWIFT : toBranch?.SW_BIC,
                    AMOUNT: amount,
                    PMTDET: form.getFieldValue('BENEFTAXID')===null || form.getFieldValue('BENEFTAXID')===undefined || form.getFieldValue('BENEFTAXID')=== '' ? form.getFieldValue('MAINDET')+" "+detail : form.getFieldValue('PMTDET'),
                    mainDetail: form.getFieldValue('BENEFTAXID') === null || form.getFieldValue('BENEFTAXID') === undefined || form.getFieldValue('BENEFTAXID') === '' ? maindetail : "",
                    INFOTOBENEF: form.getFieldValue('INFOTOBENEF'),
                    NOTE: form.getFieldValue('NOTE'),
                    CUSTACCFORCOM: fromBranch?.IBAN,
                    COMMAMOUNT: comission,
                    ibankRef: ibankRef,
                    attachedPDF: pdfCount
                },
                edv : showHideEdvBox ? {
                    trnRequestType : RequestType,
                    PMTCUSTID: form.getFieldValue('PMTCUSTID2'),
                    CUSTCIF: getCurrentCompany().customerNo,
                    CUSTACC: fromBranch2?.IBAN,
                    AMOUNT: amount2,
                    BENEFNAME: form.getFieldValue('BENEFNAME'),
                    BENEFACC: form.getFieldValue('BENEFACC'),
                    BENEFBANKCODE: toBranch?.CODE,
                    BENEFBANKNAME: toBranch?.NAME,
                    PMTDET: form.getFieldValue('PMTDET2'),
                    BENEFTAXID: form.getFieldValue('BENEFTAXID'),
                    INFOTOBENEF: form.getFieldValue('INFOTOBENEF2'),
                    NOTE: form.getFieldValue('NOTE'),
                    CUSTACCFORCOM: fromBranch2?.IBAN,
                    COMMAMOUNT: checkAmountForRequest(form.getFieldValue('COMMAMOUNT2')) ?? comission,
                } : null
            }
            setRetryRequest(req);
            const data = newMoneyTransferHoks(req)
            // resetForm(form);
            // resetFormFields();
            return data;
        }
        else {
            if(retryRequest !== null)
                retryRequest['xohks']['trnRequestType'] = RequestType;
            const data  = newMoneyTransferHoks(retryRequest);
            // resetForm(form);
            // resetFormFields();
            return data;
        }


    }

    const submitHandler = async (args: any) => {
        await calculateCommission(args.AMOUNT);
        if(args.BENEFACC.length !== 28) {
            setBenefacceError(true);
        } else {
            setBenefacceError(false);
            const result = await findUserByIban(args.BENEFACC);
            if(result['status']) {
                let amount = financial(form.getFieldValue('AMOUNT'));
                let amount2 = financial(form.getFieldValue('PMTAMOUNT2'));
                let comission = financial(form.getFieldValue('CUSTACCFORCOM'));
                let comission2 = financial(form.getFieldValue('COMMAMOUNT2'));

                let pdf_files = form.getFieldValue('pdf_files') ?? [];
                modalDataInitial.pdfFiles = [];

                if (pdf_files.length > 0) {

                    for (let file of pdf_files) {
                        modalDataInitial.pdfFiles.push({
                            'label': file.name,
                            'file': file
                        })
                    }
                }

                let edv_data = (showHideEdvBox) ? {
                    title: t("newTransfer.transfer18percVAT"),
                    description: t("newTransfer.stateTreasuryAgency"),
                    data: [
                        {
                            label: t("salary.documentNo"),
                            value: args.PMTCUSTID2
                        },
                        {
                            label: t("transfers.fromAccount"),
                            value: `${fromBranch2?.IBAN} ${fromBranch2?.CCY_NAME}`
                        },
                        {
                            label: t("common.amount"),
                            value: `${amount2} ${fromBranch2?.CCY_NAME}`
                        },
                        {
                            label: t("home.commission"),
                            value: `${comission2} ${fromBranch2?.CCY_NAME}`
                        },
                        {
                            label: t("accountStatement.paymentDetails"),
                            value: args.PMTDET2 ?? ''
                        },
                        {
                            label: t("transfers.infoForBeneficiary"),
                            value: args.INFOTOBENEF2 ?? ''
                        }
                    ]
                } : null

                setModalData(old_data => ({
                    ...modalDataInitial,
                    groups: [
                        {
                            title: false,
                            tableHasBorderBottom: true,
                            data: [
                                {
                                    label: t("transfers.sender"),
                                    value: getCurrentCompany()?.name || ""
                                },
                                {
                                    label: t("salary.documentNo"),
                                    value: `${args.PMTCUSTID || ""}`
                                },
                                {
                                    label: t("transfers.fromAccount"),
                                    value: `${fromBranch?.IBAN || ""} ${fromBranch?.CCY_NAME || ""}`
                                },
                            ]
                        },
                        {
                            title: t("requisites.beneficiary"),
                            data: [
                                {
                                    label: t("requisites.name"),
                                    value: `${args.BENEFNAME || ""}`
                                },
                                {
                                    label: t("transfers.accountNumber"),
                                    value: `${args.BENEFACC?.toUpperCase() || ""}`
                                },
                                {
                                    label: t("requisites.taxID"),
                                    value: args.BENEFTAXID ?? ''
                                }
                            ]
                        },
                        {
                            title: t("requisites.beneficiaryBank"),
                            data: [
                                {
                                    label: t("requisites.code"),
                                    value: `${args.BENEFBANKCODE || ""}`
                                },
                                {
                                    label: t("requisites.name"),
                                    value: `${args.BENEFBANKNAME || ""}`
                                }
                            ]
                        },
                        {
                            title: '',
                            data: [
                                {
                                    label: t("common.amount"),
                                    value: `${amount || ""} ${fromBranch?.CCY_NAME || ""}`
                                },
                                {
                                    label: t("home.commission"),
                                    value: `${comission || ""} ${fromBranch?.CCY_NAME || ""}`
                                },
                                {
                                    label: t("accountStatement.paymentDetails"),
                                    value: args.MAINDET ? `${args.MAINDET} ${args.PMTDET || ""}` : `${args.PMTDET || ""}`
                                },
                                {
                                    label: t("transfers.infoForBeneficiary"),
                                    value: args.INFOTOBENEF || ''
                                },
                                args.NOTE !== undefined ? {
                                    label: t("newTransfer.note"),
                                    value: args.NOTE || ''
                                } : undefined,
                            ].filter(Boolean)
                        }
                    ],
                    edvInfoData: edv_data,
                    alertText: result?.message || '',  // Добавляем проверку на существование result и fallback значение
                }));


                setNextModalVisible(old_value => true);
            }
        }
    }

    const getFileList = (info : any) => {
        form.setFieldsValue({
            'pdf_files' : info.fileList
        });
    }

    const calculateCommission = async (e: any) => {
  try {
    let value;
    if (e?.target !== undefined) {
      value = checkAmountForRequest(e.target.value);
    } else {
      value = checkAmountForRequest(e);
    }

    console.log("va", value,amountt);

    if (value !== amountt) {
      setCalcEdv("");
      form.setFieldsValue({ PMTAMOUNT2: "" });
    }

    if (isNaN(value)) {
      setCommissionLoading(false);
      form.setFieldsValue({ CUSTACCFORCOM: "" });
      setCommissionAmount("");
      return;
    }

    if (value > 40000) {
      setAmountError(true);
      return;
    }

    setAmountError(false);
    setCommissionLoading(true);

    const calc_percent = (value * 18) / 100;

    if (value !== amountt) {
      form.setFieldsValue({ PMTAMOUNT2: calc_percent });
      setCalcEdv(calc_percent);
      if (showHideEdvBox) await calculateCommission2(calc_percent);
    } else {
      if (showHideEdvBox)
        await calculateCommission2(form.getFieldValue("PMTAMOUNT2"));
    }

    const res = await getCustomerCommission({
      PAYMENT_TYPE: "XOHKS",
      CIF: getCurrentCompany().customerNo,
      CUSTACC: fromBranch?.IBAN,
      AMOUNT: value,
      CUR: fromBranch?.CCY_NAME,
      BENEFBANKCODE: form.getFieldValue("BENEFBANKCODE"),
      BENEFACC: form.getFieldValue("BENEFACC")?.toUpperCase(),
      BENEFTAXID: form.getFieldValue("BENEFTAXID"),
      PMTDET: form.getFieldValue("PMTDET"),
    });

    setCommissionLoading(false);

    const commission = res?.COM_AMOUNT ?? "";
    form.setFieldsValue({ CUSTACCFORCOM: commission });
    setAmountt(value);
    setCommissionAmount(commission);
  } catch (error) {
    console.error("Commission fetch error:", error);
    setCommissionLoading(false);
    form.setFieldsValue({ CUSTACCFORCOM: "" });
    setCommissionAmount("");
  }
};


    const onCloseSuccessModal = () => {
        resetForm(form);
        resetFormFields();
    }


    const removeFile = (index:any)=>{
        const myNewFiles = [...fileList]
        myNewFiles.splice(index, 1);
        setFileList(myNewFiles)
    }
    const calculateCommission2 = async (e: any) => {
  try {
    const getValue = e?.target?.value ? e.target.value : e;
    const parsedValue = parseFloat(getValue?.toString().replace(/\s/g, ''));
    const value = parsedValue.toFixed(2);

    if (isNaN(Number(value))) {
      setCommissionLoading2(false);
      form.setFieldsValue({ COMMAMOUNT2: "" });
      setCalcEdv("");
      setCommissionAmount2("");
      return;
    }

    const amountValue = parseFloat(
      form.getFieldValue("AMOUNT")?.toString().replace(/\s/g, "")
    );
    const calc_percent = (amountValue * 18) / 100;

    setCommissionLoading2(true);
    setCalcEdv(value);
    const res = await getCustomerCommission({
      PAYMENT_TYPE: "EDV",
      CIF: getCurrentCompany().customerNo,
      CUSTACC: fromBranch?.IBAN,
      AMOUNT: value,
      CUR: fromBranch?.CCY_NAME,
      BENEFBANKCODE: form.getFieldValue("BENEFBANKCODE"),
      BENEFACC: form.getFieldValue("BENEFACC")?.toUpperCase(),
      BENEFTAXID: form.getFieldValue("BENEFTAXID"),
      PMTDET: form.getFieldValue("PMTDET"),
    });

    setCommissionLoading2(false);

    const commission = res.COM_AMOUNT ?? "";

    form.setFieldsValue({ COMMAMOUNT2: commission });
    setCommissionAmount2(commission);
  } catch (err) {
    console.error("Commission2 fetch error:", err);
    setCommissionLoading2(false);
    form.setFieldsValue({ COMMAMOUNT2: "" });
    setCalcEdv("");
    setCommissionAmount2("");
  }
    };


    const checkVoen = (e) => {
        let value=e?.target?.value;

        if (value?.length > 0 && value?.length  < 10){
            setVoenError(true)
        }else{
            setTimeout(() => { calculateCommission({target: {value :form.getFieldValue('AMOUNT') }}) }, 100)
            setVoenError(false)
        }
    }

    const openSaveAsTemplateModal = async () => {
        setBenefacceError(false);
        const result = await findUserByIban(form.getFieldValue('BENEFACC') !== undefined ? form.getFieldValue('BENEFACC') : '');
        if(result['status']) {
            setSaveAsTemplatePopupVisible(old_data => false)
            form.validateFields().then(res => {
                setSaveAsTemplatePopupVisible(old_data => true)
            }).catch(err_input_list => {

            })
        }
    }

    const updateDocumentNumberAndCommission = (data) => {
        loadDataTemplate(data)
    }

    const findUserByIban = async (e) => {
        let value=e.trim();
        if(value.length) {
            let amount=checkAmountForRequest(form.getFieldValue('AMOUNT'));
            let amount2=checkAmountForRequest(form.getFieldValue('PMTAMOUNT2')) ?? null;
            let comission=checkAmountForRequest(form.getFieldValue('CUSTACCFORCOM')) ?? null;
            const req = {
                pmtId: form.getFieldValue('PMTCUSTID'),
                pmtStatus: null,
                pmtCreatedByUser: null,
                pmtCreatedByName: null,
                pmtCreatedDate: null,
                createdFromTempl: null,
                templName: null,
                custCIF1: getCurrentCompany().customerNo,
                custCIF2: null,
                custName: fromBranch?.NICKNAME,
                custTaxId: null,
                custAcc: fromBranch?.IBAN,
                custAccType: fromBranch?.ACCOUNT_TYPE,
                custAccCurr: fromBranch?.CCY_NAME,
                commCode: null,
                benefName: form.getFieldValue('BENEFNAME'),
                benefTaxId: form.getFieldValue('BENEFTAXID'),
                benefAcc: form.getFieldValue('BENEFACC') !== undefined && form.getFieldValue('BENEFACC') !== null ? form.getFieldValue('BENEFACC').toString().toUpperCase() : '' ,
                benefBankCode: form.getFieldValue('BENEFBANKCODE'),
                benefBankName: toBranch?.NAME,
                benefBankSWIFT: toBranch?.SW_BIC,
                pmtAmount: amount,
                commAmount: comission,
                budgetClassCode: null,
                budgetLevelCode: null,
                pmpDet: form.getFieldValue('PMTDET'),
                infoToBenef: form.getFieldValue('INFOTOBENEF'),
                lang: "AZE",
                pmtTypeCode: "XOHKS",
            };
            const getData= await GetCustomerBenefAccountData(getCurrentCompany(), req);
            if(getData['IB4C_Check_BenefAcc_Resp'] !== null && getData['IB4C_Check_BenefAcc_Resp']['msgStatus'] === "FAILURE")
            {
                setBenefacceError(true);
                setIbanMessage(getData['IB4C_Check_BenefAcc_Resp']['msgRemark'])
                form.validateFields(['BENEFACC']);
                const respons = {"status": false, "message": getData['IB4C_Check_BenefAcc_Resp']['msgRemark']}
                return respons;
            } else if (getData['IB4C_Check_BenefAcc_Resp'] !== null) {
                setBenefacceError(false);
                setIbanMessage('')
                const respons = {"status": true, "message": ''}
                return respons;
            } else {
                setBenefacceError(true);
                setIbanMessage('')
                form.validateFields(['BENEFACC']);
                const respons = {"status": false, "message": 'IBAN not found'}
                return respons
            }
        } else {
            const respons = {"status": true, "message": ''}
            return respons
        }
    }

    const checkAccount = (e) => {
        let value=e?.target?.value;

        if (value?.length > 0 && value?.length  < 28 || value !== undefined && value.toString().includes("BRES")){
            setBenefacceError(true)
        }else{
            setTimeout(() => { calculateCommission({target: {value :form.getFieldValue('AMOUNT') }}) }, 100)
            setBenefacceError(false)
        }
        if(value.toString().includes("BRES")){
            setIbanMessage(t('transfers.doInternalTransfer'))
        }else{
            setIbanMessage('')
        }
    }

    const onchangeEdv = async () => {
        if(!showHideEdvBox) {
            updateDocumentNumber2(true);
            calculateCommission2(calcEdv);
            getSelectedFromBranch2(fromBranch?.IBAN);
            // updateParentComponentFormData()
        } else {
            form.setFieldsValue({
                'PMTCUSTID2' : null
            });
            setDocumentNumber2(old_value => null)
            form.setFieldsValue({
                'COMMAMOUNT2' : null
            });
            form.setFieldsValue({
                'PMTAMOUNT2' : null
            });
            form.setFieldsValue({
                'PMTDET2' : null
            });
            form.setFieldsValue({
                'INFOTOBENEF2' : null
            });
            // updateParentComponentFormData()
        }
        setShowHideEdvBox(old_value => !showHideEdvBox);
        setTax_required(!tax_required);

    }
    const handleMainDet= (value:any)=>{
        setMainDet(value)
        setIsTouched(true);
        setHasError(value === null || value === undefined);


    }
    return (
        <>
            <Row>
                <Col flex={'700px'} className="own-account">
                    <Card bordered={false}>
                        <Row justify='start' className="own-account__form">
                            <Form
                                labelCol={{ flex: '190px'}}
                                wrapperCol={{ flex: 1 }}
                                className='full'
                                onSubmit={(e) => e.preventDefault(e)}
                                onFinish={submitHandler}
                                id={'form'}
                                form={form}
                                autoComplete="off"
                                onValuesChange={updateParentComponentFormData}
                                scrollToFirstError={{
                                    behavior: 'smooth',
                                    block: 'center',
                                    inline: 'center',
                                }}
                            >

                                { !addOrEditPage && <div className='flex ' >
                                    <InputField
                                        labelItem={t("salary.documentNo")}
                                        placeholder={t("salary.automatically")}
                                        name={'PMTCUSTID'}
                                        required={true}
                                        form={form}
                                        value={documentNumber}
                                        message={true}
                                        maxLength={25}
                                        allowLatinNumber ={true}
                                    />

                                    <Button
                                        size={'large'}
                                        icon={<SaveIco />}
                                        className="blue-button transfer__button flex align_center justify_center create_tr_template_btn"
                                        onClick={e => { setShowHideEdvBox(true); setTemplatePopupVisible(true)}}
                                    >
                                        {OWNACCOUNT.PATTERN}
                                    </Button>
                                </div> }

                                <SelectField
                                    labelItem={t("transfers.fromAccount")}
                                    placeholder={t("accountStatement.chooseAccount")}
                                    options={fromSelectOptions}
                                    name={'CUSTACC'}
                                    onChange={getSelectedFromBranch}
                                    required={true}
                                    form={form}
                                    account={true}
                                    notFoundContent={!loadingAccount ? t("newTransfer.noAccountCorrespondingCurrency") : undefined }
                                    defaultValue={ibanNumber.ccy_name?.toString()?.toLowerCase() === 'azn' ? ibanNumber.iban : undefined}
                                />

                                <Divider plain orientation="left" className={'tab_divider_left'} >Alan</Divider>

                                <InputField
                                    labelItem={t("requisites.name")}
                                    placeholder={t("newTransfer.nameBeneficiary")}
                                    maxLength={35}
                                    name={'BENEFNAME'}
                                    required={true}
                                    showCount={true}
                                    allowLatin={true}
                                    form={form}
                                    readOnly={!fromBranch?.ACCOUNT_NO}
                                    className={'isDisabled'}
                                />

                                <InputField
                                    labelItem={t("deposit.accountNumber")}
                                    placeholder=""
                                    maxLength={'28'}
                                    name={'BENEFACC'}
                                    required={true}
                                    allowLatin={true}
                                    form={form}
                                    readOnly={!fromBranch?.ACCOUNT_NO}
                                    className={'is_upper_case isDisabled'}
                                    onBlur={checkAccount}
                                    message={ibanMessage !== '' ? ibanMessage : t("newTransfer.enterValidAccount")}
                                    notValid={benefacceError}
                                    upper={true}
                                    account={true}
                                />

                                <div className={'flex pos_rel'}>
                                    <InputField
                                        labelItem={t("requisites.taxID")}
                                        placeholder=""
                                        maiLength={'10'}
                                        maxLength={'10'}
                                        isNumeric={true}
                                        onlyNumber={true}
                                        name={'BENEFTAXID'}
                                        form={form}
                                        readOnly={!fromBranch?.ACCOUNT_NO}
                                        onBlur={checkVoen}
                                        className={'isDisabled'}
                                        required={tax_required}
                                        message={t("newTransfer.enterValidTaxID")}
                                        notValid={voenError}
                                    />

                                    {/*{*/}
                                    {/*    voenError && <span className={'form_error_span form_error_span2'}>{t("newTransfer.enterValidTaxID")}</span>*/}
                                    {/*}*/}
                                </div>

                                <Divider plain orientation="left" className={'tab_divider_left'} >{t("newTransfer.beneficiaryBank")}</Divider>


                                <div className='flex'>
                                    <InputField
                                        labelItem={t("requisites.code")}
                                        placeholder={t("newTransfer.atLeast2Char")}
                                        allowClear={true}
                                        className="not_show_required_props isReadOnly ant-input-border"
                                        name={'BENEFBANKCODE'}
                                        value={formFields?.BENEFBANKCODE}
                                        required={true}
                                        isNumeric={true}
                                        onlyNumber={true}
                                        maxLength={'6'}
                                        form={form}
                                        readOnly={!fromBranch?.ACCOUNT_NO}
                                        onKeyUp={() => { updateBankCodes(false) }}
                                        autoComplete={true}
                                        options={bankCodes}
                                        filterRowClick={updateToBankCodeAndName}
                                    />
                                    <Col flex="40px" style={{marginLeft : 10}} >
                                        <Button
                                            size={'large'}
                                            icon={<SearchIco />}
                                            className="blue-button transfer__button flex align_center justify_center search_btn"
                                            onClick={() => { updateBankCodes(true) }}
                                            disabled={!fromBranch?.ACCOUNT_NO}
                                        >
                                        </Button>
                                    </Col>
                                </div>

                                <Modal
                                    title={t("newTransfer.searchByBankName")}
                                    closeIcon={<ModalCloseIco />}
                                    centered
                                    visible={codeModalVisible}
                                    onOk={() => setCodeModalVisible(false)}
                                    onCancel={() => setCodeModalVisible(false)}
                                    width={700}
                                    className={'manage_faster_menus swift_modal table_scroll_modal'}
                                    keyboard={false}
                                    focusTriggerAfterClose={false}
                                    footer={false}
                                >


                                    <Form
                                        layout="vertical"
                                        onFinish={(e) => {}}
                                        autoComplete="off"
                                    >
                                        <table className={'table table-hover swift_table b_code_table'}>
                                            <thead>
                                            <tr>
                                                <th>
                                                    <InputField
                                                        labelItem={t("requisites.code")}
                                                        placeholder={t("newTransfer.atLeast2Char")}
                                                        className={'hide_placeholder_on_focus input-border-modal'}
                                                        value={formFields?.BENEFBANKCODE}
                                                        name={'BENEFBANKCODE_FILTER'}
                                                        form={form}
                                                        isNumeric={true}
                                                        onlyNumber={true}
                                                        maxLength={'6'}
                                                        onKeyUp={() => { updateBankCodes(true) }}
                                                        suffix={<Button onClick={() => { updateBankCodes(true) }} type={"ghost"} className={'transparent'} icon={<InputSearchIco />} />}
                                                    />
                                                </th>

                                                <th>
                                                    <InputField
                                                        labelItem={t("requisites.name")}
                                                        placeholder={t("transfers.atLeast3Char")}
                                                        className={'hide_placeholder_on_focus input-border-modal'}
                                                        allowLatin={true}
                                                        name={'BENEFBANKNAME_FILTER'}
                                                        form={form}
                                                        onKeyUp={() => { updateBankCodes(true) }}
                                                        suffix={<Button onClick={() => { updateBankCodes(true) }} type={"ghost"} className={'transparent'} icon={<InputSearchIco />} />}
                                                    />
                                                </th>
                                            </tr>
                                            </thead>

                                            <tbody>
                                            {
                                                bankCodes?.map(row => {
                                                    return (
                                                        <tr onClick={() => { updateToBankCodeAndName(row) }} >
                                                            <td>{row.CODE}</td>
                                                            <td>{row.NAME}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                            </tbody>
                                        </table>
                                    </Form>


                                </Modal>

                                <InputField
                                    labelItem={t("requisites.name")}
                                    placeholder=""
                                    className=" dark-input isReadOnly"
                                    readOnly={true}
                                    allowLatin={true}
                                    form={form}
                                    name={'BENEFBANKNAME'}
                                    value={formFields?.BENEFBANKNAME}
                                />

                                <Divider className='no_text' />



                                <div className={'flex pos_rel'}>
                                    <AmountField
                                        labelItem={t("common.amount")}
                                        placeholder=""
                                        suffix={fromBranch?.CCY_NAME}
                                        name={'AMOUNT'}
                                        className={`amount_and_commission_col amount_input isDisabled`}
                                        required={true}
                                        form={form}
                                        disabled={!fromBranch?.ACCOUNT_NO}
                                        onBlur={calculateCommission}
                                    />

                                    <Col className={'commission_col mobile-select'}>
                                        <InputField
                                            labelCol={2}
                                            labelItem={t("home.commission")}
                                            placeholder=""
                                            className={"dark-input commission_input commission_border isReadOnly"}
                                            suffix={fromBranch?.CCY_NAME}
                                            name={'CUSTACCFORCOM'}
                                            value={commissionAmount}
                                            hasLoading={commissionLoading}
                                            form={form}
                                            readOnly={!fromBranch?.ACCOUNT_NO}
                                            required={true}
                                            message={''}
                                            notValid={form.getFieldValue('CUSTACCFORCOM') == ''}
                                        />
                                    </Col>

                                    {
                                        amountError && <span className={'form_error_span '}>{t("newTransfer.mustSendViaAZIPS")}</span>
                                    }
                                </div>

                                { form.getFieldValue('BENEFTAXID')===null || form.getFieldValue('BENEFTAXID')===undefined || form.getFieldValue('BENEFTAXID')=== '' ?
                                    <div> <Form.Item
                                        label={t("accountStatement.mainPayment")}
                                        name={'MAINDET'}
                                        form={form}
                                        rules={[
                                            {
                                                required: true,
                                                message: t("newTransfer.requiredField"),

                                            },
                                        ]}
                                        validateTrigger="onBlur"
                                    >
                                        <Select
                                            status={hasError && isTouched ? 'error' : ''}
                                            style={{
                                                width: '100%',

                                            }}
                                            onChange={(value: string) => handleMainDet(value)}
                                            size="large"
                                            value={maindetail}
                                            // required={true}
                                            placeholder={t("transfers.select")}
                                            disabled={!fromBranch}
                                            options={optionsDet}
                                            loading={dropListLoading}

                                        />

                                    </Form.Item>
                                        <TextAreaField
                                            visible={true}
                                            labelItem={t("accountStatement.additionalPaymentDetails")}
                                            placeholder=""
                                            showCount={true}
                                            maxLength={'105'}
                                            name={'PMTDET'}
                                            required={false}
                                            message={t("newTransfer.requiredField")}
                                            form={form}
                                            allowLatin={true}
                                            readOnly={!fromBranch?.ACCOUNT_NO}
                                            className={'isReadOnly'}
                                        />
                                    </div>
                                    : <TextAreaField
                                        visible={true}
                                        labelItem={t("accountStatement.paymentDetails")}
                                        placeholder=""
                                        showCount={true}
                                        maxLength={'140'}
                                        name={'PMTDET'}
                                        required={true}
                                        form={form}
                                        // allowDestination={true}
                                        allowLatin={true}
                                        disabled={!fromBranch?.ACCOUNT_NO}
                                        className={'isDisabled'}
                                    />}
                                <TextAreaField
                                    visible={true}
                                    labelItem={t("transfers.infoForBeneficiary")}
                                    placeholder=""
                                    showCount={true}
                                    maxLength={'195'}
                                    className={'no_required isDisabled'}
                                    name={'INFOTOBENEF'}
                                    form={form}
                                    readOnly={!fromBranch?.ACCOUNT_NO }
                                    allowLatin={true}
                                />

                                <div className={'flex edv_checkbox'} >
                                    <Col flex={'190px'} >
                                        &nbsp;
                                    </Col>
                                    <Checkbox
                                        disabled={!fromBranch?.ACCOUNT_NO}
                                        onChange={(e) => { onchangeEdv() }}
                                        checked={showHideEdvBox}
                                    >
                                        {t("newTransfer.create18percVATtransfer")}
                                    </Checkbox>
                                </div>

                                {
                                    showHideEdvBox && <div  className='box_row_edv' >
                                        { !addOrEditPage &&
                                            <InputField
                                                labelItem={t("salary.documentNo")}
                                                placeholder={t("salary.automatically")}
                                                name={'PMTCUSTID2'}
                                                required={true}
                                                form={form}
                                                value={documentNumber2}
                                                message={true}
                                                maxLength={25}
                                                allowLatinNumber ={true}
                                            />
                                        }
                                        <SelectField
                                            labelItem={t("transfers.fromAccount")}
                                            placeholder={t("accountStatement.chooseAccount")}
                                            options={toSelectOptions}
                                            name={'CUSTACC2'}
                                            required={true}
                                            form={form}
                                            onChange={getSelectedFromBranch2}
                                            value={fromBranch?.IBAN}
                                        />

                                        <div className={'flex'}  >
                                            <AmountField
                                                labelItem={t("common.amount")}
                                                placeholder=""
                                                suffix={'AZN'}
                                                name={'PMTAMOUNT2'}
                                                className={'amount_and_commission_col amount_input'}
                                                required={true}
                                                form={form}
                                                value={calcEdv}
                                                onBlur={calculateCommission2}
                                            />

                                            <Col className={'commission_col mobile-select'} >
                                                <InputField
                                                    labelCol={2}
                                                    labelItem={t("home.commission")}
                                                    placeholder=""
                                                    className="dark-input commission_input isReadOnly"
                                                    readOnly={true}
                                                    suffix="AZN"
                                                    name={'COMMAMOUNT2'}
                                                    value={commissionAmount2}
                                                    hasLoading={commissionLoading2}
                                                    form={form}
                                                    required={showHideEdvBox}
                                                    message={''}
                                                    notValid={form.getFieldValue('COMMAMOUNT2') == ''}
                                                />
                                            </Col>
                                        </div>

                                        <TextAreaField
                                            visible={true}
                                            labelItem={t("accountStatement.paymentDetails")}
                                            placeholder=""
                                            showCount={true}
                                            maxLength={'140'}
                                            name={'PMTDET2'}
                                            required={true}
                                            form={form}
                                            allowLatin={true}
                                        />

                                        <TextAreaField
                                            visible={true}
                                            labelItem={t("transfers.infoForBeneficiary")}
                                            placeholder=""
                                            showCount={true}
                                            maxLength={'195'}
                                            className={'no_required'}
                                            form={form}
                                            name={'INFOTOBENEF2'}
                                            allowLatin={true}
                                        />

                                        <div className={'flex'}>
                                            <Col flex={'170px'} >
                                                &nbsp;
                                            </Col>
                                            <span>{t("newTransfer.stateTreasuryAgency")}</span>
                                        </div>

                                    </div>
                                }

                                <div className={'flex'}>
                                    <Col flex={1}>
                                        <TextAreaField
                                            visible={visible}
                                            className='not-required plus_minus_area isDisabled'
                                            labelItem={t("newTransfer.note")}
                                            placeholder={t("newTransfer.notTransferableToBank")}
                                            showCount={true}
                                            maxLength={'180'}
                                            name={'NOTE'}
                                            readOnly={!fromBranch?.ACCOUNT_NO }
                                            form={form}
                                            // allowAllSymboll={true}
                                            allowLatin={true}
                                        />
                                    </Col>
                                    <Button
                                        className="icon-button add-remove-btn"
                                        icon={visible ? <MinusSmallIco /> : <PlusSmallIco />}
                                        onClick={() => setVisible(!visible)}
                                    />
                                </div>

                                <FileUpload
                                    className='file-upload isDisabled'
                                    labelItem={t("newTransfer.attachPDF")}
                                    accept="application/pdf"
                                    multiple={false}
                                    required={false}
                                    form={form}
                                    name={'pdf_files'}
                                    onChange={getFileList}
                                    fileLimit={10}
                                    checkSize={true}
                                    disabled={!fromBranch?.ACCOUNT_NO }
                                    editFileList={fileList}
                                    ibankRef={ibankRef}
                                    editOrRepeat={editOrRepeat}
                                    removeFile={removeFile}
                                />

                                { !addOrEditPage && <div  className='flex button_row' >
                                    <Button
                                        size={'large'}
                                        icon={<SaveBlueIco />}
                                        className="light-button btn save_btn flex align_center justify_center"
                                        htmlType={"button"}
                                        onClick={openSaveAsTemplateModal}
                                        disabled={amountError}
                                    >
                                        {OWNACCOUNT.SAVE}
                                    </Button>

                                    <div className={'flex flex_wrap'}>


                                        <Button

                                            size={'large'}
                                            icon={<RefreshIco />}
                                            className="light-button refresh_btn btn flex align_center justify_center"
                                            onClick={(e) => { resetFormFields(); resetForm(form) }}
                                        >
                                            {t(OWNACCOUNT.REFRESH)}
                                        </Button>

                                        <Button
                                            size={'large'}
                                            htmlType="submit"
                                            disabled={amountError}
                                            className="blue-button next_btn btn flex align_center justify_center"
                                        >
                                            {OWNACCOUNT.NEXT}
                                        </Button>
                                    </div>

                                </div> }

                            </Form>
                        </Row>
                    </Card>
                </Col>
            </Row>

            <NextModal
                errorIcon={<EroorIco />}
                callBackApi={newTransferFunc}
                visible={nextModalVisible}
                // onClose={setNextModalVisible}
                onClose= {() => {setNextModalVisible(false); setRetryRequest(null); }}
                onCloseSuccessModal={() => { onCloseSuccessModal() }}
                data={modalData}
                className={'transfer_own_account'}
                nextModalTitle={t("home.transfer")}
                nextModalText={`Əməliyyat uğurla saxlanılmış, imzalanmışdır və banka göndərilməsini gözləməkdədir.`}
                currentForm={form}
                transfer={true}
                tableData={tableData}
                repeatPdfList={fileList}

                editTransfer={ibankRef !== undefined && ibankRef !== '' && ibankRef !== null}
            />

            <TemplatePopup
                visible={templatePopupVisible}
                onClose={()=> {setTemplatePopupVisible(false);}}
                trnType={'XOHKS'}
                currentForm={form}
                updateAfterTemplate={updateDocumentNumberAndCommission}
            />

            <SaveAsTemplate
                visible={saveAsTemplatePopupVisible}
                onClose={setSaveAsTemplatePopupVisible}
                trnType={'XOHKS'}
                currentForm={form}
            />

            {
                loadingData ? <FullScreenLoading /> : <></>
            }

        </>
    )
}

const mapDispatchToProps = {setIbanNumber}

const mapStateToProps = (state: any, ownProps : any) => ({
    ownProps : ownProps,
    ibanNumber: (state.accountsStatement && state.accountsStatement.ibanNumber) ? state.accountsStatement.ibanNumber : {}
});

export default connect(mapStateToProps, mapDispatchToProps)(Hoks)
